<script>
import { Doughnut } from 'vue-chartjs';

export default {
  extends: Doughnut,
  props: {
    chartdata: {
      type: Object,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
    legendPosition: {
      type: String,
      default: 'right',
    },
  },
  watch: {
    legendPosition(n, o) {
      console.log(n, o);
      if (n && n != o) {
        this.renderChart(this.chartdata, this.options);
      }
    },
  },
  mounted() {
    this.renderChart(this.chartdata, this.options);
  },
};
</script>

<style>
</style>